@if(menuItems && !disabled) {
<div class="dropdown-container">
  <button [type]="type" [disabled]="disabled" (click)="toggleDropdown()" [ngClass]="customClass">
    <ng-container *ngIf="icon && iconPosition === 'left'">
      <i class="fa fa-chevron-down"></i>
    </ng-container>
    {{ label }}
    <ng-container *ngIf="icon && iconPosition === 'right'">
      <i class="fa fa-chevron-down"></i>
    </ng-container>
  </button>
  <div class="dropdown-list" *ngIf="showDropdown">
    <div class="dropdown-item">
      <!-- Iterate through categories -->
      <div *ngFor="let category of objectKeys(menuItems)">
        <div class="category-title">{{ category }}</div>

        <!-- Iterate through menu items for each category -->
        <div *ngFor="let menuItem of menuItems[category]">
          <!-- Only display menu items with "display" status as "y" -->
          <div *ngIf="menuItem.display === 'y'" class="mt-1">
            <ppl-menu-button [label]="menuItem.menu_label ?? ''" [customClass]="'fancy-button'" [iconPosition]="'right'"
              [item]="menuItem" (click)="OnMenuClick(menuItem)"></ppl-menu-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}